export const CONTEXT_AUTH = "RUTA40-ADMIN-01";

export const PASSWORD_REGEXP = /^(?!.*[`~\\%"'<>\s;:,])(?!.*--)(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=[\]{}|?/])[A-Za-z\d!@#$%^&*()_\-+=[\]{}|?/]{8,20}$/;

export const MEMBER_ROLE = {
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_MANAGER: "ROLE_MANAGER",
    ROLE_RENT_MANAGER: "ROLE_RENT_MANAGER",
    ROLE_B2B_MANAGER: "ROLE_B2B_MANAGER",
    ROLE_USER: "ROLE_USER",
    ROLE_APPLICATION: "ROLE_APPLICATION",
};

export const PAGE_LOGIN = "/login";
export const PAGE_DASHBOARD = "/admin/dashboard";
export const PAGE_LIST_USERS = "/admin/users";

export const PAGE_LIST_SELLED_CAR = "/admin/sell/car";
export const PAGE_LIST_RENT_CAR = "/admin/rent/car";
export const PAGE_LIST_COUPON = "/admin/coupon";
export const PAGE_LIST_ORDERS = "/admin/sell/orders";
export const PAGE_LIST_CUSTOMER = "/admin/sell/customer";
export const PAGE_LIST_REFERENCEROOM = "/admin/sell/reference";
export const PAGE_LIST_SEELED_CAR_MEDIAS = "/admin/sell/medias";
export const PAGE_LIST_NOTICE = "/admin/sell/notice";

export const PAGE_LIST_RESERVATION = "/admin/rent/reservation";
export const PAGE_LIST_INFORMATION = "/admin/rent/information";
export const PAGE_LIST_QUESTIONS = "/admin/rent/questioins";
export const PAGE_LIST_MANUALS = "/admin/rent/manuals";
export const PAGE_LIST_RENT_CAR_MEDIAS = "/admin/rent/medias";
export const PAGE_LIST_RENT_NOTICE = "/admin/rent/notice";
export const PAGE_LIST_RENT_STATISTICS = "/admin/rent/statistics";
export const PAGE_LIST_RENT_REVIEW = "/admin/rent/review";
export const PAGE_LIST_RENT_B2B = "/admin/rent/b2b";
export const PAGE_LIST_RENT_PEAK_SEASON = "/admin/rent/peak-season";

export const PAGE_LIST_DIGITAL_KEY = "/admin/digitalkey";
export const PAGE_LIST_CARS = "/admin/cars";
export const PAGE_LIST_EVENT_CAMPINGFAIR = "/admin/event/campingfair";
export const PAGE_LIST_EVENT_CAMPINGCARSHOW = "/admin/event/campingcarshow";
export const PAGE_LIST_EVENT_AUTOSALON = "/admin/event/autosalon";
export const PAGE_LIST_EVENT_CAMPNICFAIR = "/admin/event/campnicfair";
export const PAGE_LIST_EVENT_GREENCAMP = "/admin/event/greencamp";
export const PAGE_LIST_EVENT_CAMPINGFAIR_2024 = "/admin/event/campingfair/2024";
export const PAGE_LIST_EVENT_CAMPINGFAIR_2025 = "/admin/event/campingfair/2025";
export const PAGE_LIST_SURVEYS = "/admin/event/surveys";

export const PAGE_LIST_COUNSELING = "/admin/counseling";
export const PAGE_LIST_NOTICES = "/admin/notices";
export const PAGE_LIST_RELEASE = "/admin/release";

export const PAGE_LIST_SETUP = "/admin/setup";
// export const PAGE_LIST_COLORS = "/admin/order/colors";
// export const PAGE_LIST_ORDER_OPTIONS = "/admin/order/options";
// export const PAGE_LIST_CATALOGS = "/admin/catalogs";
// export const PAGE_LIST_INFORMATION_TITLES = "/admin/information/titles";
// export const PAGE_LIST_INFORMATION_SUBTITLES = "/admin/information/subtitles";
// export const PAGE_LIST_VISITOR = "/admin/visitor";
export const FORMAT_DATE = "YYYY-MM-DD";
export const FORMAT_YEAR = "YYYY";
export const FORMAT_MONTH = "M";
export const FORMAT_DATE_KOREAN = "YYYY년 M년 D일";
export const FORMAT_DATE_TIME = "YYYY-MM-DD HH:mm:ss";
export const FORMAT_SHORT_DATE_TIME = "YY-MM-DD HH:mm:ss";
export const FORMAT_SHORT_DATE_TIME_WITHOUT_SECOND = "YY/MM/DD HH:mm";

export const COLOR_USE = "#9429FF";
export const COLOR_RETURN = "#FFCC00";
export const COLOR_ERROR = "#FF0000";

export const PAGE_SIZE = 20;
export const USER_PAGE_SIZE = 10000;

export const EMPTY_PAGE = {
    content: [],
    pageable: {
        pageSize: 0,
        pageNumber: 0,
    },
    totalElements: 0,
    totalPages: 0,
};

export const PaymentType = {
    DEPOSIT: "DEPOSIT",
    DOWN_PAYMENT: "DOWN_PAYMENT",
    BALANCE: "BALANCE",
    SUBSIDY: "SUBSIDY",
    ADDITIONAL_DOWN_PAYMENT: "ADDITIONAL_DOWN_PAYMENT",
    ADDITIONAL_BALANCE: "ADDITIONAL_BALANCE",
    REGISTRATION_FEE: "REGISTRATION_FEE",
};

export const DOOR_TYPE_DOOR = "door";
export const DOOR_TYPE_SWING = "swing";

export const DOOR_CONTROL_OPEN = "open";
export const DOOR_CONTROL_CLOSE = "close";

export const DEFAULT_USED_TIME = " 14:00:00";
export const DEFAULT_ARRIVED_TIME = " 11:00:00";

export const BATTERY_PENALTY = 600;
export const BATTERY_MAX_LIMIT = 100;

export const BOARD_ID_BEST_REVIEW = 1;
export const BOARD_ID_USER_REVIEW = 2;
